import {inject, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {BASE_URL_TOKEN, Branch, SearchCriteria} from '@raptor-fe/core';

@Injectable({
    providedIn: 'root',
})
export class BranchService {
    private readonly http = inject(HttpClient);
    private readonly base_url = `${inject(BASE_URL_TOKEN)}v1/tenant/`;

    delete(tenantId: string, id: string): Observable<object> {
        return this.http.delete(`${this.base_url}${tenantId}/branch/${id}`);
    }

    getAll(tenantId: string, allowedOnly = false): Observable<Branch[]> {
        const branchUrl = `${this.base_url}${tenantId}/Branch`;
        return this.http.get<Branch[]>(branchUrl, allowedOnly ? { params: { allowedOnly: 'true' } } : undefined);
    }

    get(tenantId: string, id: string): Observable<Branch | null> {
        if (id === null || id === undefined || id === '')
            return of(<Branch>{
                tenantId: tenantId,
                id: null,
                name: '',
                contact: {
                    tenantId: tenantId,
                    address: {
                        tenantId: tenantId,
                    },
                },
            });
        else return this.http.get<Branch>(`${this.base_url}${tenantId}/branch/${id}`);
    }

    getByTenantId(tenantId: string): Observable<Branch[]> {
        return this.http.get<Branch[]>(`${this.base_url}${tenantId}/branch`);
    }

    save(tenantId: string, branch: Branch, isNew?: boolean): Observable<Branch> {
        const url = `${this.base_url}${tenantId}/branch`;

        // If isNew is explicitly provided (true or false), use it
        // Otherwise fall back to ID-based logic
        const shouldCreate =
            isNew !== undefined
                ? isNew
                : branch.id === null || branch.id === undefined || branch.id === '';

        if (shouldCreate) {
            return this.http.post<Branch>(url, branch);
        } else {
            return this.http.put<Branch>(url, branch);
        }
    }

    search(tenantId: string, searchCriteria: SearchCriteria): Observable<Branch[]> {
        return this.http.post<Branch[]>(
            `${this.base_url}${tenantId}/branch/search`,
            searchCriteria,
        );
    }
}
